module.exports = __webpack_public_path__ + "img/8.f82807f1.jpg";